import dropin from "braintree-web-drop-in";
import { useEffect, useState } from "react";
import apiList from "services/apiList";
import { callApi } from "services/callApi";
import styled from "styled-components";
import { PrimaryButton } from "theme/globalStyle";
import { device } from "utils/helperFunctions";

export default function BraintreeDropIn(props) {
  const [braintreeInstance, setBraintreeInstance] = useState(undefined);

  useEffect(() => {
    const initializeBraintree = () =>
      dropin.create(
        {
          // insert your tokenization key or client token here
          authorization: props?.paymentSession,
          container: "#braintree-drop-in-div",
        },
        function (error, instance) {
          if (error) console.error(error);
          else setBraintreeInstance(instance);
        }
      );

    if (braintreeInstance) {
      braintreeInstance.teardown().then(() => {
        initializeBraintree();
      });
    } else {
      initializeBraintree();
    }
  }, []);

  const onPaymentCompleted = async (nonce) => {
    try {
      const apiUrl = apiList?.braintreePayment?.paymentProcess;
      let apiResponse = await callApi.post(apiUrl, {
        nonce,
        amount: props?.orderAmount,
        orderId: props?.orderId,
      });

      let regResponse = await apiResponse.json();
      if (regResponse?.status === 200) {
        props?.handlePaymentCompleted();
      } else if (regResponse?.status === 400) {
        props?.handlePaymentFailed();
      } else {
        props?.handlePaymentError();
      }
    } catch (e) {
      console.log(e);
      props?.handlePaymentFailed();
    }
  };

  return (
    <Wrapper>
      <DropinWrapper id="braintree-drop-in-div" />
      {braintreeInstance && (
        <Button
          className={"braintreePayButton"}
          disabled={!braintreeInstance}
          onClick={() => {
            if (braintreeInstance) {
              braintreeInstance.requestPaymentMethod((error, payload) => {
                if (error) {
                  console.error(error);
                } else {
                  onPaymentCompleted(payload.nonce);
                }
              });
            }
          }}
        >
          {`Pay ${
            props?.orderAmount ? `${props?.currency} ${props?.orderAmount}` : ``
          }`}
        </Button>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;
const DropinWrapper = styled.div`
  width: 100%;
  position: relative;
`;
const Button = styled(PrimaryButton)`
  width: 100%;
  position: relative;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "all")};

  @media ${device.laptop} {
    width: fit-content;
    padding: 0px 24px;
    display: flex;
    align-items: center;
    justify-self: center;
  }
`;
